import React from "react";

const DeleteDeviceModal = ({ isOpen, onClose, deletecolumn, apiLoading, selectedcolumn }) => {
  if (!isOpen) return null;

  const isAssigned =
    (selectedcolumn?.rpm?.length ?? 0) > 0 || Boolean(selectedcolumn?.patientid);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-96 p-6 relative">
        {/* Header with Close Icon */}
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-lg font-bold">Delete Device</h2>
          <button
            className="text-gray-500 text-3xl hover:text-gray-800"
            onClick={() => onClose(false)}
          >
            &times;
          </button>
        </div>

        {/* Modal Content */}
        <p className="mt-4 text-gray-700">
          Are you sure you want to permanently delete device{" "}
          <strong>{selectedcolumn?.deviceserialnumber}</strong>? This removes the
          record completely so the same device can be added and assigned again as
          new.
        </p>

        {isAssigned && (
          <p className="mt-3 text-sm text-red-600">
            This device is currently assigned to patient{" "}
            <strong>{selectedcolumn?.patientid}</strong>. Deleting it will also
            remove that assignment.
          </p>
        )}

        {/* Footer with Buttons */}
        <div className="mt-6 flex justify-end gap-2">
          <button
            className="border px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100"
            onClick={() => onClose(false)}
            disabled={apiLoading}
          >
            Cancel
          </button>
          <button
            className={`${
              apiLoading
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-red-500 text-white hover:bg-red-600"
            } px-4 py-2 rounded-md`}
            onClick={() => {
              deletecolumn();
            }}
            disabled={apiLoading}
          >
            {apiLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDeviceModal;
